import { ActionFunction, redirect } from 'react-router-dom';
import { saveData } from './saveData';

// Sentry
import * as Sentry from '@sentry/react';

// Offline / avisos
import { isOfflineQueuedError } from '../../../../../../offline/isOfflineQueuedError';
import { showSuccessToast } from '../../../../../../utils/toasts';
import i18n from '../../../../../../i18n';

export const ActionEditVehicles: ActionFunction = async ({ params }) => {
  try {
    // `await` real: sin él este catch era código muerto (la promesa rechazada
    // nunca pasaba por aquí) y el fallo quedaba silencioso.
    // `params`: el guardado escribe en el accidente de la URL (`:id`) y se
    // niega si las copias son de otro (R5, invariante I3 del spec
    // wizard-draft-ownership).
    return await saveData({ params });
  } catch (err) {
    if (isOfflineQueuedError(err)) {
      // La edición se encoló (sin red, o con red degradada tras el plazo):
      // éxito diferido. El destino lo pone quien encoló, que es el único que
      // conoce el contexto de navegación (campaña, OT o listado).
      showSuccessToast(i18n.t('modals:changeState.queuedOffline'));
      return redirect(
        (err as { redirectTo?: string }).redirectTo ?? '../../../../'
      );
    }
    Sentry.captureException(err);
    console.log('Error saving Accident:', err);
    // Re-lanzar → errorElement de la ruta. Antes: `return null` silencioso
    // (el usuario no sabía si el accidente se había guardado — clase del
    // incidente At.0001979.0008.02).
    throw err;
  }
};
